import { useCallback } from "react";
import { Popconfirm, Button, message } from "antd";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function MessageIgnoreButton({ type, size = "default", messageId, callback }) {
  const auth = useAuthContext();
  const confirmHandler = useCallback(() => {
    messageService.ignoreMessage(messageId, {}, auth.token).then(() => {
      message.success("操作成功");
      callback(Date.now());
    });
  }, [messageId, auth, callback]);
  return (
    <Popconfirm
      title="请确认?"
      onConfirm={confirmHandler}
      okText="是"
      cancelText="否"
    >
      <Button type={type} size={size}>
        不予采用
      </Button>
    </Popconfirm>
  );
}

export default MessageIgnoreButton;
